const layout = {
  state: {
    error: null,
    interactionError: null,
  },

  mutations: {
    SET_ERROR: (state, error) => {
      state.error = error
    },
    SET_INTERACTION_ERROR: (state, error) => {
      state.interactionError = error;
    },
  },

  actions: {
    ResetInteractionError({commit}) {
      commit('SET_INTERACTION_ERROR', null)
    }
  }
}

export default layout
